import { Badge, Button, Card, Col, Row, Typography } from "antd";
import classes from "./integrations.module.scss";
import { useState } from "react";
import { erpSystems } from "../Integrations/constant";
import classNames from "classnames";

const { Title } = Typography;

const ErpIntegrations = () => {
  const [integratedAppsList, setIntegratedAppsList] = useState({
    erpSystems,
  });

  return (
    <>
      <Row marginTop={20} gutter={[16, 16]}>
        {integratedAppsList.erpSystems.map((item, index) => (
          <Col span={8} key={index}>
            <Badge.Ribbon text={item.status} color={item.statusColor}>
              <div
                className={classNames({
                  [classes.cardCnt]: true,
                })}
              >
                <Card hoverable bordered className={classes.customCard}>
                  <div className={classes.cardHeader}>
                    <div className={classes.graphHeader}>
                      <div>
                        <img src={item.image} height={30} alt="qb" />
                      </div>
                      <span className={classes.title}>{item.title}</span>
                      <span className={classes.subTitle}>
                        {item.description}
                      </span>
                    </div>
                  </div>
                </Card>

                <div className={classes.wrapperContainer}>
                  <Button type="primary">
                    {item.status === "Ready" ? "Connect" : "Disconnect"}
                  </Button>
                </div>
              </div>
            </Badge.Ribbon>
          </Col>
        ))}
      </Row>
    </>
  );
};
export default ErpIntegrations;
